import { useState } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import {
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Edit as EditIcon,
  Trash2 as DeleteIcon,
} from 'react-feather';
import { useNavigate } from 'react-router';
import getInitials from 'src/utils/getInitials';
import DeleteModal from '../modal/DeleteModal';

const PlanListResults = ({
  plans,
  exclude,
  paginate,
  ...rest
}) => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    text: 'Tem certeza que deseja excluir este Cliente ?',
  });

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    paginate(newPage + 1);
  };

  const excludePlan = async (id) => {
    const confirm = await exclude(id);
    if (confirm) {
      setDeleteModal({
        ...deleteModal,
        open: false
      });
    }
  };

  const deletePlan = (id) => {
    setDeleteModal({
      ...deleteModal,
      id,
      open: true,
      confirm: excludePlan,
      cancel: () => { }
    });
  };

  const buttonEdit = (id) => {
    navigate(`/app/plan/${id}`, { replace: true });
  };
  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  Image
                </TableCell>
                <TableCell>
                  Nome
                </TableCell>
                <TableCell>
                  Tipo de Recorrencia
                </TableCell>
                <TableCell>
                  Quantia de Recorrencia
                </TableCell>
                <TableCell>
                  Valor
                </TableCell>
                <TableCell>
                  Ativo
                </TableCell>
                <TableCell>
                  Cortesia
                </TableCell>
                <TableCell>
                  Editar
                </TableCell>
                <TableCell>
                  Excluir
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plans.data.slice(0, limit).map((plan) => (
                <TableRow
                  hover
                  key={plan.id}
                >
                  <TableCell>
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      <Avatar
                        src={plan.image !== '' ? plan.image : `${process.env.REACT_APP_URL}/images/no-image.png`}
                        sx={{ mr: 2 }}
                      >
                        {getInitials(plan.name)}
                      </Avatar>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {plan.name}
                  </TableCell>
                  <TableCell>
                    {plan.recurrence}
                  </TableCell>
                  <TableCell>
                    {plan.total_charges}
                  </TableCell>
                  <TableCell>
                    {plan.value}
                  </TableCell>
                  <TableCell>
                    {plan.active ? <ThumbsUpIcon color="#05ffa1" /> : <ThumbsDownIcon color="#e34234" />}
                  </TableCell>
                  <TableCell>
                    {plan.courtesy ? <ThumbsUpIcon color="#05ffa1" /> : <ThumbsDownIcon color="#e34234" />}
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => { buttonEdit(plan.id); }} variant="contained" color="primary">
                      <EditIcon />
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => { deletePlan(plan.id); }} variant="contained" color="error">
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={plans.meta.total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={(plans.meta.current_page - 1)}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
      />
      <DeleteModal modal={deleteModal} />
    </Card>
  );
};

PlanListResults.propTypes = {
  plans: PropTypes.object.isRequired,
  exclude: PropTypes.func.isRequired,
  paginate: PropTypes.func.isRequired
};

export default PlanListResults;
